import React from 'react';
import styled from 'styled-components';

import PriceDisclaimer from '../../../../../../../../components/price-disclaimer';
import styles from './styles.module.sass';

type DisclaimerProps = {
  showRefineLink?: boolean;
};

const DisclaimerContainer = styled.div`
  flex: 1;
  margin-right: 1rem;
`;

const Disclaimer = ({ showRefineLink = true }: DisclaimerProps) => (
  <DisclaimerContainer className={styles.disclaimer}>
    <PriceDisclaimer bold highlightIncome showRefineLinkInline={showRefineLink} />
  </DisclaimerContainer>
);

export default Disclaimer;
